import { actions } from "../actions";

const initialState = {
  agencyProjects: {
    result: [],
    count: 0,
  },

  assignees: [],
  vendorTasks: {
    result: [],
    count: 0,
  },
};

export const projectsReducers = {
  agencyProjects(state = initialState.agencyProjects, action) {
    switch (action.type) {
      case actions.SET_AGENCY_PROJECTS:
        return action.payload;
      default:
        return state;
    }
  },

  assignees(state = initialState.assignees, action) {
    switch (action.type) {
      case actions.VM_SET_ASSIGNEE_PER_PROJECT:
        return action.payload;
      case actions.VM_UPDATE_ASSIGNEE_STATUS: {
        const { assigneeId, status } = action;
        return (state ?? []).map((row) =>
          row.assigneeId === assigneeId ? { ...row, status } : row
        );
      }
      default:
        return state;
    }
  },

  vendorTasks(state = initialState.vendorTasks, action) {
    switch (action.type) {
      case actions.SET_VENDOR_TASKS:
        return action.payload;
      default:
        return state;
    }
  },
};
